import React from 'react';
import PhotoUpload from './PhotoUpload';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>🎅 Santa Ops - Letter Processor</h1>
        <p>Upload a letter to Santa and extract the text!</p>
      </header>
      <main>
        <PhotoUpload />
      </main>
    </div>
  );
}

export default App;